import { render, staticRenderFns } from "./ProductTemplateUpdate.vue?vue&type=template&id=edcb8cd8"
import script from "./ProductTemplateUpdate.vue?vue&type=script&lang=js"
export * from "./ProductTemplateUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports